'use strict';

export default function () {
    return {
        restrict: 'A',
        template: require('../view/progress-metric.html'),
        scope: {
            current: '=current',
            expected: '=expected',
            unit: '=unit',
            name: '=name',
        },
        controller: [
            '$scope',
            ($scope) => {
                $scope.progressBarValue = 0;
                $scope.progressBarLineStyle = {};

                $scope.$watchGroup(
                    [
                        'current',
                        'expected',
                    ],
                    () => progressBarValue(),
                );

                function progressBarValue() {
                    if (!$scope.expected) {
                        $scope.progressBarValue = 0;
                        $scope.progressBarLineStyle = {};
                        return;
                    }
                    $scope.progressBarValue = Math.round(($scope.current / $scope.expected) * 100);
                    $scope.progressBarLineStyle = {
                        'width': `${$scope.progressBarValue}%`,
                    };
                }
            }],
    };
}
